// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.chat-menu-wrapper {
    position: relative;
    margin-left: auto;
    display: flex;
    align-items: center;
    z-index: 3;
}

.chat-menu-btn {
    background: transparent;
    border: none;
    color: #bbb;
    font-size: 12px;
    line-height: 1;
    width: 24px;
    height: 24px;
    padding: 0;
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s, color 0.15s;
}

.chat-menu-btn:hover {
    background: rgba(0,0,0,0.06);
    color: #777;
}

.chat-menu-overlay {
    position: fixed;
    inset: 0;
    z-index: 10;
}

.chat-dropdown {
    position: absolute;
    right: 0;
    bottom: 28px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.12);
    min-width: 150px;
    z-index: 11;
    overflow: hidden;
}

.chat-dropdown > button {
    display: block;
    width: 100%;
    padding: 10px 16px;
    background: transparent;
    border: none;
    text-align: left;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    transition: background 0.15s;
}

.chat-dropdown > button:hover {
    background: #f5f5f5;
}

.chat-dropdown-confirm {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    font-size: 14px;
}

.chat-dropdown-confirm span {
    color: #333;
    white-space: nowrap;
}

.chat-dropdown-confirm button {
    padding: 4px 10px;
    border-radius: 4px;
    border: 1px solid #ddd;
    cursor: pointer;
    font-size: 13px;
    background: #fff;
    transition: background 0.15s;
}

.chat-dropdown-confirm button:first-of-type {
    background: #dc3545;
    color: #fff;
    border-color: #dc3545;
}

.chat-dropdown-confirm button:first-of-type:hover {
    background: #bb2d3b;
}

.chat-dropdown-confirm button:last-of-type:hover {
    background: #f0f0f0;
}

.navbar_chat_mobile .chat-menu-wrapper {
    padding-right: 8px;
}

.navbar_chat_mobile .chat-dropdown {
    bottom: unset;
    top: 36px;
    right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,cAAc;IACd,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;IACvC,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,UAAU;AACd","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.chat-menu-wrapper {\n    position: relative;\n    margin-left: auto;\n    display: flex;\n    align-items: center;\n    z-index: 3;\n}\n\n.chat-menu-btn {\n    background: transparent;\n    border: none;\n    color: #bbb;\n    font-size: 12px;\n    line-height: 1;\n    width: 24px;\n    height: 24px;\n    padding: 0;\n    cursor: pointer;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.15s, color 0.15s;\n}\n\n.chat-menu-btn:hover {\n    background: rgba(0,0,0,0.06);\n    color: #777;\n}\n\n.chat-menu-overlay {\n    position: fixed;\n    inset: 0;\n    z-index: 10;\n}\n\n.chat-dropdown {\n    position: absolute;\n    right: 0;\n    bottom: 28px;\n    background: #fff;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.12);\n    min-width: 150px;\n    z-index: 11;\n    overflow: hidden;\n}\n\n.chat-dropdown > button {\n    display: block;\n    width: 100%;\n    padding: 10px 16px;\n    background: transparent;\n    border: none;\n    text-align: left;\n    cursor: pointer;\n    font-size: 14px;\n    color: #333;\n    transition: background 0.15s;\n}\n\n.chat-dropdown > button:hover {\n    background: #f5f5f5;\n}\n\n.chat-dropdown-confirm {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 16px;\n    font-size: 14px;\n}\n\n.chat-dropdown-confirm span {\n    color: #333;\n    white-space: nowrap;\n}\n\n.chat-dropdown-confirm button {\n    padding: 4px 10px;\n    border-radius: 4px;\n    border: 1px solid #ddd;\n    cursor: pointer;\n    font-size: 13px;\n    background: #fff;\n    transition: background 0.15s;\n}\n\n.chat-dropdown-confirm button:first-of-type {\n    background: #dc3545;\n    color: #fff;\n    border-color: #dc3545;\n}\n\n.chat-dropdown-confirm button:first-of-type:hover {\n    background: #bb2d3b;\n}\n\n.chat-dropdown-confirm button:last-of-type:hover {\n    background: #f0f0f0;\n}\n\n.navbar_chat_mobile .chat-menu-wrapper {\n    padding-right: 8px;\n}\n\n.navbar_chat_mobile .chat-dropdown {\n    bottom: unset;\n    top: 36px;\n    right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
